import { BreadcrumbNav } from "components/molecules";
import React, { useEffect, useState } from "react";
import Form from "./components/Form";
import Table from "./components/Table";

const PageMode = {
  VIEW: "view",
  ADD: "add",
  EDIT: "edit",
};

const DistribusiKelamuNasional = () => {
  const [pageMode, setPageMode] = useState(PageMode.VIEW);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    document.title = "SISMAL | Distribusi Kelambu Nasional";
  }, []);

  const changePageMode = (mode) => {
    setPageMode(mode);
  };

  const onSelectData = (item) => {
    setSelectedItem(item);
    changePageMode(PageMode.EDIT);
  };

  return (
    <div className="dashboard-wrapper">
      {(pageMode === PageMode.ADD || pageMode === PageMode.EDIT) && (
        <BreadcrumbNav
          items={[
            {
              label: "Data Dasar Kelambu",
              onClick: () => changePageMode(PageMode.VIEW),
            },
            { label: "Tambah Data Dasar Kelambu" },
          ]}
        />
      )}
      {pageMode === PageMode.VIEW && (
        <Table changePageMode={changePageMode} onSelectData={onSelectData} />
      )}
      {(pageMode === PageMode.ADD || pageMode === PageMode.EDIT) && (
        <Form
          changePageMode={changePageMode}
          pageMode={pageMode}
          item={selectedItem}
        />
      )}
    </div>
  );
};

export default DistribusiKelamuNasional;
